export function pinsRenderFailureSummary(input: {
  status: string | null | undefined;
  planDate: string;
  errorAt: string | null | undefined;
}): string | null {
  if (input.status !== 'FAILED') return null;
  const formattedPlanDate = formatWarsawDate(input.planDate);
  const formattedFailureDate = input.errorAt ? formatWarsawDate(input.errorAt) : null;
  if (!formattedFailureDate) return `Render nieudany · slot ${formattedPlanDate} bez materiału`;
  if (formattedFailureDate !== formattedPlanDate) {
    return `Render nieudany ${formattedFailureDate} · slot ${formattedPlanDate} nadal bez materiału`;
  }
  return `Render nieudany ${formattedFailureDate}`;
}

function formatWarsawDate(value: string): string {
  const date = /^\d{4}-\d{2}-\d{2}$/.test(value) ? new Date(`${value}T12:00:00Z`) : new Date(value);
  if (Number.isNaN(date.getTime())) return 'data nieznana';
  return new Intl.DateTimeFormat('pl-PL', {
    timeZone: 'Europe/Warsaw',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(date);
}
